import React from 'react';
import PathType from '../../consts/pathmodule/PathType';
import { DataGridTypes } from 'devextreme-react/data-grid';
import { formatMessage } from 'devextreme/localization';
import PathSynchroJobResumeDto from '../../classes/dtos/jobmodule/PathSynchroJobResumeDto';
import PathReportingJobResumeDto from '../../classes/dtos/jobmodule/PathReportingJobResumeDto';
import PathMetaApiReadJobResumeDto from '../../classes/dtos/jobmodule/PathMetaApiReadJobResumeDto';
import PathAIJobResumeDto from '../../classes/dtos/jobmodule/PathAIJobResumeDto';
import { JobStatusTerminated, JobStatusError, JobStatusCanceled } from '../../classes/consts/JobStatus';

import './ResumeCell.scss';

const ResumeCell = (cellData: DataGridTypes.ColumnCellTemplateData) => {

    if (cellData.value === null) {
        if ([JobStatusTerminated, JobStatusError, JobStatusCanceled].includes(cellData.data.Status.Status)) {
            return (<div>{formatMessage("ResumeCell_NoInformation")}</div>);
        }

        return null;
    }

    switch (cellData.value.PathType) {

        case PathType.DataSynchronization:
            {
                let pathSynchroJobResumeDto: PathSynchroJobResumeDto = cellData.value as PathSynchroJobResumeDto;

                if (pathSynchroJobResumeDto === null) {
                    return (<div>Synchro</div>);
                } else {

                    return (<div>
                        <div>
                            {"Added : "} <span style={{ fontWeight: "bold", color: "green", marginRight: "12px" }}>{pathSynchroJobResumeDto.Added}</span>
                            {"Updated : "} <span style={{ fontWeight: "bold", color: "green", marginRight: "12px" }}>{pathSynchroJobResumeDto.Updated}</span>
                            {"Deleted : "} <span style={{ fontWeight: "bold", color: "green", marginRight: "12px" }}>{pathSynchroJobResumeDto.Deleted}</span>
                            {"Ignored : "} <span style={{ fontWeight: "bold", color: "green" }}>{pathSynchroJobResumeDto.Ignored}</span>
                        </div>
                    </div>);
                }
            }

        case PathType.Reporting:
            {
                let pathReportingJobResumeDto: PathReportingJobResumeDto = cellData.value as PathReportingJobResumeDto;

                if (pathReportingJobResumeDto === null) {
                    return (<div>Reporting</div>);
                } else {

                    return (<div>
                        <div>
                            {"Rows count : "} <span style={{ fontWeight: "bold", color: "green", marginRight: "12px" }}>{pathReportingJobResumeDto.RowCount}</span>
                        </div>
                    </div>);
                }
            }

        case PathType.MetaApi:
            {
                let pathMetaApiReadJobResumeDto: PathMetaApiReadJobResumeDto = cellData.value as PathMetaApiReadJobResumeDto;

                if (pathMetaApiReadJobResumeDto === null) {
                    return (<div>MetaApi</div>);
                } else {

                    return (<div>
                        <div>
                            {"Rows count : "} <span style={{ fontWeight: "bold", color: "green", marginRight: "12px" }}>{pathMetaApiReadJobResumeDto.RowCount}</span>
                        </div>
                    </div>);
                }
            }

        case PathType.AI:
            {
                let pathAIJobResumeDto: PathAIJobResumeDto = cellData.value as PathAIJobResumeDto;

                if (pathAIJobResumeDto === null) {
                    return (<div>AI</div>);
                } else {

                    return (<div>
                        <div>
                            {"Rows count : "} <span style={{ fontWeight: "bold", color: "green", marginRight: "12px" }}>{pathAIJobResumeDto.RowCount}</span>
                        </div>
                    </div>);
                }
            }
    }
};

export default ResumeCell;
